import { pick } from 'ramda'
import { Product } from '@/pages/UsageCredits/types'

const getSyndicationCount = (
  values: {
    platform: string[]
    facebookProduct?: string | undefined
    craigslistProduct?: string | undefined
    zumperProduct?: string | undefined
    addons?: string[]
  },
  products: Product[]
) => {
  let count = 0
  const data = Object.values(
    pick(['facebookProduct', 'craigslistProduct', 'zumperProduct'], values)
  )?.filter(Boolean)
  data?.forEach(item => {
    const productQuantity = products?.find((x: Product) => x.priceId === item)?.quantity
    count += productQuantity ?? 0
  })
  return count
}

export default getSyndicationCount
